import AbstractScene from './AbstractScene.js';
import { Colors } from '../consts/Colors.js';
import RoundedButton2 from '../prefabs/RoundedButton2.js';
import Popup from '../prefabs/Popup.js';
import { TextContents, CartesInfos, ZonesInfos } from '../consts/DataGame2';
import Deck2 from '../prefabs/game2/Deck2.js';
import Zone2 from '../prefabs/game2/Zone2.js';

export default class Game2 extends AbstractScene {
    constructor() {
        super({
            key: "Game2"
        })
    }
    init(data) {
        this.zones = []
        this._init(data);
    }

    preload() {
        this._preload();
    }

    create() {
        this.background = this.add.image(0, 0, 'background2').setOrigin(0);
        this.addDropZone()
        this.transitionRect = this.add.rectangle(16, 16, 1888, 1048, Colors.Elmt.DarkBlue, 1).setOrigin(0, 0).setDepth(12)
        this.deck = new Deck2(this, 1664, 545)
        // this.consigne = this.createTextElement(1471, 870, TextContents.consigne)

        // this.launchPopup();

        this.transitionIn()
        // this.time.addEvent({
        //     delay: 2000,
        //     callback: () => {
        //         this.transitionOut()
        //         // this.endGame()
        //     }

        // })
    }
    launchPopup() {
        this.popup = new Popup(this, TextContents.popup.text, 720, false);
        this.popup.introBtn.setClickFunction(() => {
            this.popup.destroy();
            this.zones.forEach(zone => {
                zone.setActive();
                let delay = 0;
                let indice =[0,1,2,3,0,1,2,3]
                for (let i = 0; i < 8; i++) {
                    const elementId = indice[i];
                    const element = this.zones[elementId];
                    element.annimation(delay)
                    delay += 200

                }
            });
        })
    }

    addDropZone() {
        for (let i = 0; i < ZonesInfos.length; i++) {
            const element = ZonesInfos[i];
            let zone = new Zone2(this, element);
            this.zones.push(zone);
        }
    }
    transitionIn() {
        // this.transitionRect.setAngle(180);
        this.tweens.add({
            targets: this.transitionRect,
            duration: 500,
            ease: 'Linear',
            x: 1920,
            onComplete: () => {
                this.transitionRect.destroy()
                this.launchPopup();
            }
        })

    }
    transitionOut() {
        this.tweens.add({
            targets: this.deck,
            duration: 500,
            alpha: 0,
            onComplete: () => {
                this.transitionRect = this.add.rectangle(1904, 16, 480, 1048, Colors.Elmt.DarkBlue, 1).setOrigin(1, 0).setDepth(12)
                this.tweens.add({
                    targets: this.deck1,
                    duration: 500,
                    alpha: 0,
                    onComplete: () => {
                        this.transitionRect.setDepth(12)
                        this.tweens.add({
                            targets: this.transitionRect,
                            width: 1488,
                            duration: 500,
                            onUpdate: () => {
                                this.transitionRect.x = 1904 - this.transitionRect.width
                            },
                            onComplete: () => {
                                this.scene.start('Game3')
                                // this.scene.start('EndGame', {score: this.game.data.score})
                            }
                        })

                    }
                })

            }
        })

    }


}